import { SharesTitle, Transaction } from 'types';

export const getTitleByTransaction = (
  sharesTitles: SharesTitle[],
  transaction: Transaction
) =>
  sharesTitles?.find(
    (title: SharesTitle) => title?.operation?._id === transaction?.operation
  );
